@let items = entities();
<section class="px-xs !py-lg h-full bg-white" hlmCard>
  <div class="px-md flex items-center justify-between">
    <h3 hlmCardTitle>Liste des certifications</h3>
  </div>
  <div class="ml-sm w-1/2">
    <app-input-search (onFilter)="filtres.set($event)" placeholder="Recherchez une certification" />
  </div>

  @if (items.length) {
    <div hlmTableContainer hlmCardContent>
      <table hlmTable>
        <thead hlmTHead>
          <tr hlmTr>
            <th hlmTh>Libellé de la certification</th>
            <th hlmTh>Trigramme type</th>
          </tr>
        </thead>
        <tbody hlmTBody>
          @for (item of items; track item.id) {
            <tr hlmTr>
              <td class="text-decoration-underline" [hlmTooltipTrigger]="item.nom" hlmTd>{{ item.nom }}</td>
              <td hlmTd>
                <hlm-select
                  id="select-type-trigramme"
                  (valueChange)="setTrigrammeType($event, item.id)"
                  scrollable="true"
                  placeholder="Sélectionner un trigramme"
                >
                  <hlm-select-trigger>
                    {{ item.trigrammeType ?? 'Aucun trigramme' }}
                  </hlm-select-trigger>
                  <hlm-select-content>
                    <hlm-select-scroll-up />
                    @for (trigramme of trigrammes() | trierPar: 'nom'; track $index) {
                      <hlm-option [value]="trigramme.code">{{ trigramme.code }}</hlm-option>
                    }
                    <hlm-select-scroll-down />
                  </hlm-select-content>
                </hlm-select>
              </td>
            </tr>
          }
        </tbody>
      </table>

      <app-paginateur [store]="store" />
    </div>
  } @else if (filtres()?.nom) {
    <div class="border-grey-2 px-md pb-xxl h-full rounded-lg border">
      <app-empty-state title="Tapez le nom d'une certification dans la barre de recherche.">
        <span class="paragraph-medium-medium text-content-secondary text-center"
          >Veuillez taper le nom d’une certification présente sur la base de données de
          <a [href]="urlFranceCompetences" hlmBtn variant="link" size="compact" target="_blank">France Compétences</a
          >.</span
        >
      </app-empty-state>
    </div>
  } @else {
    <div class="border-grey-2 px-md pb-xxl rounded-lg border">
      <app-empty-state
        isCertification
        title="Commencez à rechercher une certification grâce à la barre de recherche."
        type="certification"
      />
    </div>
  }
</section>
